import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NotesIcon from '@mui/icons-material/Notes';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import GroupIcon from '@mui/icons-material/Group';
import PaginationControls from './PaginationControls';

export default function EventFilters({
  selectedFilters,
  onFilterChange,
  pageSize,
  onPageSizeChange,
  currentPage,
  totalEvents,
  onPreviousPage,
  onNextPage,
  hasMore
}) {
  const handleChange = (event, newFilters) => {
    if (newFilters.length > 0) {
      onFilterChange(newFilters);
    }
  };

  const buttonStyle = (isSelected) => ({
    color: isSelected ? 'primary.main' : 'grey.500',
    '&.Mui-selected': { color: 'primary.main', backgroundColor: 'action.selected' },
    p: 0.25,
    minWidth: 28,
    minHeight: 28
  });

  return (
    <Box sx={{ mt: 0.5, pt: 0.5, px: 1, borderTop: 1, borderColor: 'divider' }}>
      {/* Single row with filters on left, controls on right */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
        {/* Event Type Filters - Left side */}
        <ToggleButtonGroup
          value={selectedFilters}
          onChange={handleChange}
          aria-label="event type filters"
          size="small"
        >
          <ToggleButton
            value="match"
            aria-label="match events"
            sx={buttonStyle(selectedFilters.includes('match'))}
          >
            <PersonSearchIcon sx={{ fontSize: 16 }} />
          </ToggleButton>
          <ToggleButton
            value="note"
            aria-label="note events"
            sx={buttonStyle(selectedFilters.includes('note'))}
          >
            <NotesIcon sx={{ fontSize: 16 }} />
          </ToggleButton>
          <ToggleButton
            value="assignment"
            aria-label="assignment events"
            sx={buttonStyle(selectedFilters.includes('assignment'))}
          >
            <AssignmentIcon sx={{ fontSize: 16 }} />
          </ToggleButton>
          <ToggleButton
            value="group_match"
            aria-label="group match events"
            sx={buttonStyle(selectedFilters.includes('group_match'))}
          >
            <GroupIcon sx={{ fontSize: 16 }} />
          </ToggleButton>
        </ToggleButtonGroup>

        {/* Pagination Controls - Right side */}
        <PaginationControls
          pageSize={pageSize}
          onPageSizeChange={onPageSizeChange}
          currentPage={currentPage}
          totalEvents={totalEvents}
          onPreviousPage={onPreviousPage}
          onNextPage={onNextPage}
          hasMore={hasMore}
        />
      </Box>
    </Box>
  );
}
